export default {
	props: {
		id: {
			type: Number,
			required: true,
		}
	},
	data() {
		return {
			resource: {
				can: {},
			}
		}
	},
	methods: {
		getResource() {
			this.$wait.start('fetching view resource');

			this.fetchResource().then(response => {
				this.resource = response;
                console.log("resource view: ", this.resource);
			}).finally(() => {
				this.$wait.end('fetching view resource');
			});
		},
		fetchResource() {
			return Promise.reject("Not implemented");
		},
	},
	beforeRouteUpdate(to, from, next) {
		this.id = parseInt(to.params.id);
		this.getResource();
		next();
	},
	created() {
		this.getResource();
	},
}
